<template>
  <div>
    <Row class="p-b-10">
      <i-col span="24">
        <span class="workplatform-title">{{ contractInfo.name }}</span>
        <span class="m-l-10 workplatform-title">{{ contractInfo.code }}</span>
        <a class="text-blue-500 m-l-10" @click="changeContractCode"><Icon type="md-create" class="m-r-2" />编辑合同编号</a>
        <!-- <Tag class="m-l-5" color="green" v-if="!showDisCount">
          {{contract.contractCategoryName}}
        </Tag>
        <Tag
          class="m-l-5"
          color="blue"
          v-else-if="contract.contractCategory === 2"
          >{{contract.contractCategoryName}}</Tag
        >
        <Tag class="m-l-5" color="blue" v-else-if="contract.type === 3"
          >代理商合同</Tag
        > -->
      </i-col>
    </Row>

    <template v-if="contractInfo.id">
      <Row>
        <!-- <i-col span="24">
          <span  class="title"> 发布类型 </span>
          <span>{{ contract.contractCategoryName||'无' }}</span>
        </i-col> -->
        <!-- <i-col span="24" v-if="contract.salePolicy===2">
          <span  class="title"> 发布标记 </span>
          <span>{{ contract.salePolicyName }}</span>
        </i-col> -->
        <i-col span="24" class="p-b-5">
          <span class="title"> 甲方 </span>
          <span>{{ contractInfo.firstParty.partyName || "无" }}</span>
        </i-col>
        <i-col span="8"
          ><span class="title">法定代表人 </span
          >{{ contractInfo.firstParty.partyLegalName }}</i-col
        >
        <i-col span="8"
          ><span class="title"
            >{{
              contractInfo.firstParty.partyType === 10
                ? "社会统一信用代码"
                : "身份证号"
            }} </span
          >{{ contractInfo.firstParty.partyOrgCode }}</i-col
        >
        <i-col span="8"
          ><span class="title">地址 </span
          >{{ contractInfo.firstParty.partyAddress }}</i-col
        >
      </Row>
      <Row class="p-b-5">
        <i-col span="8"
          ><span class="title">创建人</span
          >{{ contractInfo.createUserName }}</i-col
        >
        <i-col span="8"
          ><span class="title">创建时间 </span
          >{{ contractInfo.createTime }}</i-col
        >
      </Row>

      <Row class="p-b-10">
        <i-col span="24" class="p-t-5 p-b-5">
          <span class="title">乙方 </span>
          <span class="m-r-10">{{ contractInfo.secondParty.partyName }}</span>
          <Tag v-if="contractInfo.secondParty.partyType===10" color="green">企业</Tag>
          <Tag v-else color="cyan">个人</Tag>
          <a class="text-blue-500 m-l-10" @click="changeSecondParty">
            <Icon type="md-create" class="m-r-2" />编辑乙方联系方式
          </a>
        </i-col>
        <template v-if="contractInfo.secondParty.partyType === 10">
          <!-- <i-col span="8"
            ><span class="title">法定代表人 </span
            >{{ contractInfo.secondParty.partyLegalName }}</i-col
          >
          <i-col span="8"
            ><span class="title">公司电话 </span
            >{{ contractInfo.secondParty.tel }}</i-col
          >
           -->
          <i-col span="8"
            ><span class="title">统一社会信用代码 </span
            >{{ contractInfo.secondParty.partyOrgCode }}</i-col
          >
          <i-col span="8"
            ><span class="title">联系人 </span
            >{{ contractInfo.secondParty.delegateName }}</i-col
          >
          <i-col span="8"
            ><span class="title">联系人电话 </span
            >{{ contractInfo.secondParty.delegatePhone }}</i-col
          >
        </template>
        <template v-else>
          <!-- <i-col span="8"
            ><span class="title">承租人 </span
            >{{ contractInfo.secondParty.partyName }}</i-col
          > -->
          <i-col span="8"
            ><span class="title">承租人电话 </span
            >{{ contractInfo.secondParty.partyPhone }}</i-col
          >
          <i-col span="8"
            ><span class="title">身份证号 </span
            >{{ contractInfo.secondParty.partyOrgCode }}</i-col
          >
        </template>

        <i-col span="8"
          ><span class="title">地址 </span
          >{{ contractInfo.secondParty.partyAddress }}</i-col
        >
      </Row>
    </template>

    <div style="font-size: 14px">合同日期</div>
    <Row :gutter="8" class="mb-2">
      <i-col span="24">
        <Form
          ref="contractDateSettingForm"
          :model="contractDateSettingModel"
          :rules="rules"
          :label-width="120"
        >
          <Row :gutter="8">
            <i-col span="6">
              <FormItem prop="startDate" label="合同开始日期">
                <DatePicker
                  v-model="contractDateSettingModel.startDate"
                  type="date"
                  placeholder="设置合同开始日期"
                  class="w-full"
                />
              </FormItem>
            </i-col>

            <i-col span="6">
              <FormItem prop="endDate" label="合同结束日期">
                <DatePicker
                  v-model="contractDateSettingModel.endDate"
                  type="date"
                  placeholder="设置合同结束日期"
                  class="w-full"
                />
              </FormItem>
            </i-col>
            <!-- <i-col span="6">
              <FormItem prop="businessDate" label="最晚运营时间">
                <DatePicker
                  v-model="contractDateSettingModel.businessDate"
                  type="date"
                  placeholder="最晚运营时间"
                  class="w-full"
                />
              </FormItem>
            </i-col> -->
            <i-col span="6">
              <FormItem prop="signDate" label="合同签订日期">
                <DatePicker
                  v-model="contractDateSettingModel.signDate"
                  type="date"
                  placeholder="设置合同签订日期"
                  class="w-full"
                />
              </FormItem>
            </i-col>
          </Row>
        </Form>
      </i-col>
    </Row>
    <p class="text-14 p-b-5">合同附加条款</p>
    <Row :gutter="8">
      <i-col span="24">
        <Input
          v-model="contractDateSettingModel.description"
          type="textarea"
          :rows="5"
          placeholder="请输入合同附加条款.."
        />
      </i-col>
    </Row>

    <row class="p-b-10 p-t-10">
      <i-col span="24" class="text-right">
        <Button type="info" @click="handleNextStep">下一步</Button>
      </i-col>
    </row>

    <!-- 弹窗修改合同乙方 -->
    <Modal v-model="modalUpdateParty" width="600" @on-ok="handleSaveContractParty">
      <p slot="header" class="text-center">
        <Icon type="md-create" class="m-r-5"></Icon>
        <span>编辑合同乙方</span>
      </p>

      <Form ref="updatePartyModel" :model="updatePartyBean" autocomplete="on" label-position="top">
        <template v-if="contractInfo.id">
          <Row v-if="contractInfo.secondParty.partyType === 10" :gutter="16">
            <i-col span="12">
              <FormItem label="联系人姓名">
                <Input
                  v-model="updatePartyBean.delegateName"
                  size="small"
                  placeholder="请输入公司联系人"
                />
              </FormItem>
            </i-col>
            <i-col span="12">
              <FormItem  label="联系人电话">
                <Input
                  v-model="updatePartyBean.delegatePhone"
                  size="small"
                  placeholder="请输入联系人电话号码"
                />
              </FormItem>
            </i-col>
          </Row>
          <Row v-else :gutter="16">
            <i-col span="12">
              <FormItem label="承租人">
                <Input
                  v-model="updatePartyBean.partName"
                  size="small"
                  placeholder="请输入承租人姓名"
                />
              </FormItem>
            </i-col>
            <i-col span="12">
              <FormItem  label="联系电话">
                <Input
                  v-model="updatePartyBean.partPhone"
                  size="small"
                  placeholder="请输入承租人联系电话"
                />
              </FormItem>
            </i-col>
          </Row>
        </template>

        <FormItem label="详细地址">
          <Input
            type="text"
            size="small"
            v-model="updatePartyBean.partyAddress"
            placeholder="请输入客户详细地址"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
// import { getPositions } from '@/api/product/resource'
// import { addDevice, updateDevice } from '@/api/product/deviceedit'
import { toMoney } from '@/utils/wnumb_own'
import { ParseDate } from '@/utils/dateFormat'
import { updateContractCode, addContractDate, updateParty } from '@/api/invest/contract'
/** new api */

export default {
  components: {},
  props: {},
  data () {
    return {
      contractCode: '',
      contractDateSettingModel: {
        contractId: 0,
        signDate: '',
        startDate: '',
        endDate: '',
        businessDate: ''
      },
      rules: {
        startDate: [{ required: true, message: '请选择合同开始时间' }],
        endDate: [{ required: true, message: '请选择合同结束时间' }]
      },

      modalUpdateParty: false,
      updatePartyBean: {
        partId: null,
        delegateName: null,
        delegatePhone: null,
        partName: null,
        partPhone: null,
        partyAddress: null
      }
    }
  },
  mounted () {},
  created () {
    this.contractDateSettingModel.startDate = this.contractInfo.startDate
    this.contractDateSettingModel.signDate = this.contractInfo.signDate
    this.contractDateSettingModel.endDate = this.contractInfo.endDate
    this.contractDateSettingModel.businessDate = this.contractInfo.businessDate
    this.contractDateSettingModel.description = this.contractInfo.description
  },
  methods: {
    formatMoney (number) {
      return toMoney(number)
    },
    changeContractCode () {
      this.contractCode = this.contractInfo.code
      this.$Modal.confirm({
        title: '自定义合同编号',
        render: (h) => {
          return h('Input', {
            props: {
              value: this.contractCode,
              autofocus: true,
              placeholder: '请填写新的合同编号'
            },
            on: {
              input: (val) => {
                this.contractCode = val
              }
            }
          })
        },
        loading: true,
        onOk: () => {
          updateContractCode({
            code: this.contractCode,
            contractId: this.contractInfo.id
          })
            .then((res) => {
              if (res && !res.errcode) {
                this.$Notice.success({ desc: '编辑合同编号成功！' })
                this.$store.commit('set_contract_update', new Date())
              }
              this.$Modal.remove()
            })
            .catch((error) => {
              this.$Modal.remove()
              this.$Notice.error({
                title: '服务器请求错误',
                desc: error
              })
            })
        }
      })
    },
    changeSecondParty () {
      this.modalUpdateParty = true

      this.updatePartyBean.partId = this.contractInfo.secondParty.id
      this.updatePartyBean.partyAddress = this.contractInfo.secondParty.partyAddress
      if (this.contractInfo.secondParty.partyType === 10) {
        this.updatePartyBean.delegateName = this.contractInfo.secondParty.delegateName
        this.updatePartyBean.delegatePhone = this.contractInfo.secondParty.delegatePhone
      } else {
        this.updatePartyBean.partName = this.contractInfo.secondParty.partyName
        this.updatePartyBean.partPhone = this.contractInfo.secondParty.partyPhone
      }
    },
    handleSaveContractParty () {
      updateParty(this.updatePartyBean).then(res => {
        if (res) {
          this.$Notice.success({ desc: '编辑合同乙方成功！' })
          this.$store.commit('set_contract_update', new Date())
        }
      })
    },
    handleNextStep () {
      this.$refs.contractDateSettingForm.validate((valid) => {
        if (valid) {
          if (this.contractDateSettingModel.startDate) {
            this.contractDateSettingModel.startDate = ParseDate(
              this.contractDateSettingModel.startDate
            )
          }
          if (this.contractDateSettingModel.endDate) {
            this.contractDateSettingModel.endDate = ParseDate(
              this.contractDateSettingModel.endDate
            )
          }
          if (this.contractDateSettingModel.businessDate) {
            this.contractDateSettingModel.businessDate = ParseDate(
              this.contractDateSettingModel.businessDate
            )
          }
          if (this.contractDateSettingModel.signDate) {
            this.contractDateSettingModel.signDate = ParseDate(
              this.contractDateSettingModel.signDate
            )
          }
          this.contractDateSettingModel.contractId = this.contractInfo.id
          addContractDate(this.contractDateSettingModel).then((res) => {
            this.$store.commit('set_contract_currentStep', 'price')
            this.$store.commit('set_contract_update', new Date())
          })
          // this.$Modal.confirm({
          //   title: '操作提示',
          //   content: '请确认合同基本信息是否填写完整？',
          //   onOk: () => {

          //   }
          // })
        } else {
          this.$Notice.error({ desc: '请正确输入信息' })
        }
      })
    }
  },
  watch: {
    contractInfo () {
      this.contractDateSettingModel.startDate = this.contractInfo.startDate
      this.contractDateSettingModel.signDate = this.contractInfo.signDate
      this.contractDateSettingModel.endDate = this.contractInfo.endDate
      this.contractDateSettingModel.businessDate = this.contractInfo.businessDate
      this.contractDateSettingModel.description = this.contractInfo.description
    }
  },
  computed: {
    contractInfo () {
      return this.$store.state.investmentContract.contractInfo
    }
  }
}
</script>
